export default "__VITE_ASSET__DXBvxkYc__"